import { render } from "./MailDebug.vue?vue&type=template&id=2103b006"
import script from "./MailDebug.vue?vue&type=script&lang=js"
export * from "./MailDebug.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__